module.exports = __webpack_public_path__ + "static/carousel-2-41911da5e07f0b73645b3bff34ad71e2.png";